import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchCurrency } from '../actions/currencyAction'; 

export function useCurrency() {
  const currency = useSelector((state) => state.currency);
  // console.log({currency});
  return currency?.currency || "";
}

export function useFetchCurrency() {
  const dispatch = useDispatch();

  // Créez une fonction pour déclencher l'action fetchCurrency
  const fetchCurrencyData = () => {
    dispatch(fetchCurrency());
  };

  return fetchCurrencyData;
}

// import { useCurrency } from './useCurrency';

// function MonComposant() {
//   const currency = useCurrency();

//   ...
// }